import React, { useEffect, useState } from 'react';
import { Menu, X, ChevronRight } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Industries',
    href: '#industries'
  }, {
    name: 'Success Stories',
    href: '#testimonials'
  }, {
    name: 'Process',
    href: '#process'
  }, {
    name: 'FAQ',
    href: '#faq'
  }];
  return <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-charcoal-900/95 backdrop-blur-md py-3 shadow-lg' : 'bg-transparent py-4'}`} data-id="element-247">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-248">
        <div className="flex justify-between items-center" data-id="element-249">
          <div className="flex-shrink-0 flex items-center" data-id="element-250">
            <a href="#" className="flex flex-col items-center leading-none" aria-label="Nexora Resume home" data-id="element-251">
              <img src="https://cdn.magicpatterns.com/uploads/w9WU4iE2GPyhrtXEUgkLSw/ChatGPT_Image_Jun_25,_2026,_07_14_34_PM.png" alt="Nexora Resume" className="h-12 w-auto object-contain" data-id="element-252" />
              <span className="mt-1 text-white font-serif-display text-sm font-bold tracking-[0.25em] uppercase" data-id="element-253">
                Nexora<span className="text-gold" data-id="element-254"> Resume</span>
              </span>
            </a>
          </div>

          <div className="hidden lg:flex items-center gap-x-9" data-id="element-255">
            <ul className="flex items-center gap-x-9" data-id="element-256">
              {navLinks.map(link => <li key={link.name} data-id="element-257">
                  <a href={link.href} className="relative whitespace-nowrap text-gray-300 hover:text-white transition-colors text-[13px] font-medium uppercase tracking-[0.12em] after:absolute after:left-0 after:-bottom-1.5 after:h-px after:w-0 after:bg-gold after:transition-all after:duration-300 hover:after:w-full" data-id="element-258">
                    {link.name}
                  </a>
                </li>)}
            </ul>

            <span className="h-5 w-px bg-white/15" aria-hidden="true" data-id="element-259"></span>

            <a href="#contact" className="bg-gold hover:bg-gold-600 text-navy-900 px-6 py-2.5 rounded-sm font-semibold text-sm transition-all duration-300 flex items-center group whitespace-nowrap" data-id="element-260">
              Consultation
              <ChevronRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" data-id="element-261" />
            </a>
          </div>

          <div className="lg:hidden flex items-center" data-id="element-262">
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="text-white hover:text-gold transition-colors" data-id="element-263">
              {mobileMenuOpen ? <X className="w-6 h-6" data-id="element-264" /> : <Menu className="w-6 h-6" data-id="element-265" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && <div className="lg:hidden bg-charcoal-900 border-t border-charcoal-700 absolute w-full" data-id="element-266">
          <div className="px-4 pt-2 pb-6 space-y-1 shadow-xl" data-id="element-267">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="block px-3 py-3 text-base font-medium text-gray-300 hover:text-gold hover:bg-charcoal-700 rounded-md" data-id="element-268">
                {link.name}
              </a>)}
            <a href="#contact" onClick={() => setMobileMenuOpen(false)} className="block mt-4 text-center bg-gold text-navy-900 px-3 py-3 rounded-sm font-semibold text-base" data-id="element-269">
              Schedule Consultation
            </a>
          </div>
        </div>}
    </nav>;
}